import { STORAGE_KEYS } from "../constants/defaults";

function canUseLocalStorage() {
  try {
    return typeof window !== "undefined" && !!window.localStorage;
  } catch {
    return false;
  }
}

function readJson(key, fallback) {
  if (!canUseLocalStorage()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // noop
  }
}

export const simulationBaseRepositoryMock = {
  loadState() {
    return {
      machines: readJson(STORAGE_KEYS.baseMachines, null),
      teams: readJson(STORAGE_KEYS.baseTeams, null),
      maintenanceSchedule: readJson(STORAGE_KEYS.baseMaintenance, null),
      teamAbsences: readJson(STORAGE_KEYS.baseTeamAbsences, null),
      teamBoosts: readJson(STORAGE_KEYS.baseTeamBoosts, null),
      contractHoursCalendar: readJson(STORAGE_KEYS.baseContractHoursCalendar, null),
    };
  },

  saveState({
    machines,
    teams,
    maintenanceSchedule,
    teamAbsences,
    teamBoosts,
    contractHoursCalendar,
  }) {
    if (Array.isArray(machines)) writeJson(STORAGE_KEYS.baseMachines, machines);
    if (Array.isArray(teams)) writeJson(STORAGE_KEYS.baseTeams, teams);
    if (Array.isArray(maintenanceSchedule)) {
      writeJson(STORAGE_KEYS.baseMaintenance, maintenanceSchedule);
    }
    if (Array.isArray(teamAbsences)) writeJson(STORAGE_KEYS.baseTeamAbsences, teamAbsences);
    if (Array.isArray(teamBoosts)) writeJson(STORAGE_KEYS.baseTeamBoosts, teamBoosts);
    if (Array.isArray(contractHoursCalendar)) {
      writeJson(STORAGE_KEYS.baseContractHoursCalendar, contractHoursCalendar);
    }
  },
};

export default simulationBaseRepositoryMock;
